export type { TFormErrors } from '@common/RestRouter/definitions'

export type { TRouteParams } from '@common/Router/definitions'

export {
  EProductRoute,
  ECategoryRoute,
  EContactUsRoute,
  ENewsletterRoute
} from '../backend/definitions'

export type {
  TDigestProducts,
  IProductGetResponse,
  IProductsGetResponse,
  ICategoryGetAllResponse,
  INewsletterInsertRequest,
  IProductsGetTopProductsResponse
} from '../backend/definitions'

export enum ERoute {
  Main = '/',
  Impressum = '/impresszum',
  DataManagementInformation = '/adatkezelesi-tajekoztato',
  Gtc = '/aszf',
  Product = '/termek/:sku/:name'
}

export const LG_VIEWPORT_WIDTH = 992

export interface ISwiper extends HTMLElement {
  readonly initialize: TVoidCallback
}
